import { Dimensions } from 'react-native';
import palette from './colours.json';

// Dimensions

const { width: vw, height: vh } = Dimensions.get('window');

// Fonts

const colors = {
  ...palette,
  modalBg: 'rgba(0, 0, 0, 0.8)',
  gradient: `linear-gradient(to bottom right, ${palette.teal}, ${palette.greenDark})`,
  pools: {
    timers: [
      {
        name: 'Green',
        color: palette.green,
      },
      {
        name: 'Purple',
        color: palette.purple,
      },
      {
        name: 'Blue',
        color: palette.blue,
      },
      {
        name: 'Yellow Dark',
        color: palette.yellowDark,
      },
      {
        name: 'Orange',
        color: palette.orange,
      },
      {
        name: 'Deep Orange',
        color: palette.deepOrange,
      },
      {
        name: 'Orange Dark',
        color: palette.orangeDark,
      },
      {
        name: 'Red',
        color: palette.red,
      },
      {
        name: 'Red Dark',
        color: palette.redDark,
      },
      {
        name: 'Indigo',
        color: palette.indigo,
      },
      {
        name: 'Teal',
        color: palette.teal,
      },
    ],
    // The fixed six-colour palette from FR-4. No free colour picker, no custom hex.
    // Uppercased because colours.json stores hex in lowercase, but persisted
    // modifier-style colours and the server's validation set use uppercase.
    modifiers: [
      { name: 'Indigo', color: palette.indigoDark.toUpperCase() },
      { name: 'Purple', color: palette.purpleDark.toUpperCase() },
      { name: 'Light Green', color: palette.lightGreenDark.toUpperCase() },
      { name: 'Teal', color: palette.tealDark.toUpperCase() },
      { name: 'Lime', color: palette.limeDark.toUpperCase() },
      { name: 'Grey', color: palette.grey7.toUpperCase() },
    ],
  },
};

const fonts = {
  regular: 'Inter-Regular',
  medium: 'Inter-Medium',
  semibold: 'Inter-Semibold',
  bold: 'Inter-Bold',
};

// Shadows

const shadow = {
  light: {
    shadowColor: palette.black,
    shadowOpacity: 0.15,
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 6,
    elevation: 3,
  },
  strong: {
    shadowColor: palette.black,
    shadowOpacity: 0.3,
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: 6,
    elevation: 6,
  },
};

// Border Radii

const radius = {
  s: 4,
  m: 6,
  l: 10,
};

const elevations = {
  sidebar: 2,
};

export default {
  fonts,
  shadow,
  radius,
  colors,
  window: {
    vw,
    vh,
  },
  elevations,
};
